import React from 'react';
import '../assets/jqBootstrapValidation.js';

import $ from 'jquery';    

import { connect } from 'react-redux';

class EmailForm extends React.Component {
    
    componentDidMount() {

        var form = $(this.refs.form);

        form.find('input')
            .jqBootstrapValidation({
                
                preventSubmit:true,
                sumbitError: ($form, event, errors) => {},
                submitSuccess: ($form, event) => {
                    event.preventDefault();

                    // get values from FORM
                    var firstName = form.find("input#firstName").val();
                    var lastName = form.find("input#lastName").val();
                    var telephone = form.find("input#telephone").val();
                    var address = form.find("input#address").val();
                    var message = form.find("textarea#message").val();
                    var sendMeACopy = form.find("input#sendMeACopy")[0].checked;

                    var data = { firstName, lastName, telephone, address, message, sendMeACopy}

                    console.log(data);


                    $.ajax({
                        url: "./send_email.php",
                        type: "POST",
                        data: data,
                        cache: false,

                        success: function(data) {
                            console.log('success');
                            form.trigger("reset");
                        },

                    })

                }

            })
    }

    submitForm() {

    }

    render() { 

        let { lastName, firstName, telephone, email, message, sendMeACopy, send } = this.props;

        return (
        <form name="email" ref="form" className="email-form" id="contactForm" onSubmit={ this.submitForm } noValidate>

            <div className="row">
                <div className="col-sm-6 col-xs-12">
                    <div className="form-group">
                        <input type="text" className="form-control" placeholder={lastName} id="lastName" required data-validation-required-message="Enter your name please." />
                        <p className="help-block text-danger"></p>
                    </div>
                </div>
                <div className="col-sm-6 col-xs-12">
                    <div className="form-group">
                        <input type="text" className="form-control" placeholder={firstName} id="firstName" required data-validation-required-message="Enter your First Name please." />
                        <p className="help-block text-danger"></p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-6 col-xs-12">
                    <div className="form-group">
                        <input type="tel" className="form-control" placeholder={telephone} id="telephone" required data-validation-required-message="Enter your phone number please." />
                        <p className="help-block text-danger"></p>
                    </div>
                </div>

                <div className="col-sm-6 col-xs-12">
                    <div className="form-group">
                        <input type="email" className="form-control" placeholder={email} id="address" required data-validation-required-message="Enter your email address please." />
                        <p className="help-block text-danger"></p>
                    </div>
                </div>
                
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <div className="form-group">
                        <textarea className="form-control" placeholder={message} id="message" rows="10" required data-validation-required-message="Your Message"></textarea>
                        <p className="help-block text-danger"></p>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <div className="checkbox">
                        <label>
                          <input type="checkbox" id="sendMeACopy"/> {sendMeACopy}
                        </label>
                    </div>
                    <div id="success"></div>
                    <button type="submit" className="btn btn-lg">{send}</button>
                </div>
            </div>

        </form>

    )

    }

}


const mapStateToProps = ({currentLocale, dictionaries}) => {
    return {
        lastName : dictionaries[currentLocale]["emailForm"]["lastName"],
        firstName : dictionaries[currentLocale]["emailForm"]["firstName"],
        telephone : dictionaries[currentLocale]["emailForm"]["telephone"],
        email : dictionaries[currentLocale]["emailForm"]["email"],
        
        message : dictionaries[currentLocale]["emailForm"]["message"],
        sendMeACopy : dictionaries[currentLocale]["emailForm"]["sendMeACopy"],
        send : dictionaries[currentLocale]["emailForm"]["send"]
    }
}

export default connect(mapStateToProps)(EmailForm);


/** WEBPACK FOOTER **
 ** ./src/components/EmailForm.jsx
 **/